// extracted by mini-css-extract-plugin
module.exports = {"container":"SettingsListItem_container__28-1j","nameContainer":"SettingsListItem_nameContainer__3mRla","name":"SettingsListItem_name__21mnZ"};